import comp from "./DynamicTableRow";
export default comp;
